export default class BurgerMenu {
  constructor(element) {
    this.el = element;
    this.checkbox = this.el.querySelector('[data-item="burger-checkbox"]');
    this.searchToggle = this.el.querySelector('[data-item="search-toggle"]');
    this.closeSearch = this.el.querySelector('[data-item="search-close"]');
    this.searchContainer = this.el.querySelector('[data-component="search-container"]');
    this.body = document.querySelector('body');
    this.inputField = this.el.querySelector('[data-item="search-input"]');

    this.searchForm = this.el.querySelector('[data-item="search-form"]');

    this.handleSearchToggleClick = this.handleSearchToggleClick.bind(this);
    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.handleCloseSearchClick = this.handleCloseSearchClick.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.url = this.searchForm.getAttribute('data-url');

    this.init();
  }

  init() {
    this.searchToggle.addEventListener('click', this.handleSearchToggleClick);
    this.checkbox.addEventListener('click', this.handleCheckboxClick);
    this.closeSearch.addEventListener('click', () => {
      this.handleCloseSearchClick();
      this.toggleSearchContainerVisibility(true);
    });
    this.searchForm.addEventListener('submit', this.handleSubmit);

    this.toggleSearchContainerVisibility(true);
  }

  handleAreaLabel(labelText) {
    this.searchToggle.setAttribute('aria-label', labelText);
  }

  toggleSearchContainerVisibility(hidden) {
    const visibilityDelay = 300;
    if (hidden) {
      setTimeout(() => {
        this.searchContainer.style.visibility = 'hidden';
        this.searchContainer.setAttribute('aria-hidden', true);
      }, visibilityDelay);
    } else {
      this.searchContainer.style.visibility = 'visible';
      this.searchContainer.setAttribute('aria-hidden', false);
    }
  }

  toggleSearchToggle() {
    const isChecked = this.searchToggle.checked;
    if (isChecked) {
      document.addEventListener('click', this.handleDocumentClick);
    }
    this.searchToggle.style.display = isChecked ? 'none' : '';
    this.body.classList.toggle('overflow-y-hidden', this.checkbox.checked);
  }

  // Define the handleSubmit function
  handleSubmit = e => {
    e.preventDefault();

    let inputValue = this.inputField.value;

    // Clean and trim the input value
    if (inputValue) {
      inputValue = decodeURIComponent(inputValue.replace(/"/g, '')).trim();
    }

    if (this.url) {
      window.location.href = `${this.url}?query=${encodeURIComponent(inputValue)}`;
    } else {
      window.location.href = `${this.url}`;
    }
  };

  handleSearchToggleClick() {
    this.checkbox.checked = false;
    this.toggleSearchToggle();
    this.toggleSearchContainerVisibility(false);
    this.inputField.focus();
    this.handleAreaLabel('Close Search');
  }

  handleCheckboxClick() {
    this.searchToggle.checked = false;
    this.toggleSearchToggle();
    this.toggleSearchContainerVisibility(this.checkbox.checked);
    this.handleAreaLabel(this.checkbox.checked ? 'Close Search' : 'Open Search');
  }

  handleCloseSearchClick() {
    document.removeEventListener('click', this.handleDocumentClick);
    this.searchToggle.checked = false;
    this.toggleSearchToggle();
    this.searchToggle.focus();
    this.handleAreaLabel('Open Search');
  }

  handleDocumentClick(e) {
    if (!this.el.contains(e.target)) {
      this.handleCloseSearchClick();
    }
  }
}
